const API_BASE_URL = process.env.REACT_APP_API_URL;

class ApiProductService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    const token = localStorage.getItem('clientToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async getProducts(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/publico/obtener_productos_shop`);
  }

  async getProduct(slug) {
    return this.request(`/publico/obtener_producto_slug/${slug}`);
  }

  async getCategories() {
    return this.request('/publico/lista_categorias');
  }
}

export default new ApiProductService();